<template>
    <div>
        <a-card>
            <a-steps>
                <a-step :status="basicStatus" :title="$t('global.basicInfo')">
                    <a-icon :type="basicStatus == 'process' ? 'loading' : 'idcard'" slot="icon"/>
                </a-step>
                <a-step :status="locateStatus" :title="$t('org.locationInfo')">
                    <a-icon :type="locateStatus == 'process' ? 'loading' : 'environment'" slot="icon"/>
                </a-step>
                <a-step :status="userStatus" :title="$t('org.userInfo')">
                    <a-icon :type="userStatus == 'process' ? 'loading' : 'user'" slot="icon"/>
                </a-step>
                <a-step :status="customerStatus" :title="$t('org.customInfo')">
                    <a-icon :type="customerStatus == 'process' ? 'loading' : 'customer-service'" slot="icon"/>
                </a-step>
            </a-steps>

            <a-form :form="basicForm" v-show="basicStatus == 'process'">
                <a-form-item :label="level == 2 ? $t('org.integrator') : $t('org.orgName')" v-bind="formItemLayout">
                    <a-input size="small" v-model="orgName" v-decorator="['orgName',{ rules: [
                    { required: true, message: level == 2 ? $t('org.validateTip.integratorRequired') : $t('org.validateTip.orgNameRequired')  },
                    { max: 30, message: level == 2 ? $t('org.validateTip.integratorRule') : $t('org.validateTip.orgNameRule')},
                    { validator: hasSpecialChar},
                    { validator: queryHasSameOrgName}
                    ],
                    validateTrigger: 'blur' }]"></a-input>
                </a-form-item>

                <a-form-item :label="level == 2 ? $t('org.integratorDescription') : $t('org.orgDescription')" v-bind="formItemLayout">
                    <a-textarea size="small" v-model="orgDescription" v-decorator="['orgDescription',{ rules: [{ required: true, message: level == 2 ? $t('org.validateTip.integratorDescriptionRequired') : $t('org.validateTip.orgDescriptionRequired')  }, { max: 200, message: level == 2 ? $t('org.validateTip.integratorDescriptionRule') : $t('org.validateTip.orgDescriptionRule')}] }]"></a-textarea>
                </a-form-item>

                <a-form-item :label="$t('org.parentName')" v-bind="formItemLayout">
                    <a-input size="small" v-model="parentOrg" disabled></a-input>
                </a-form-item>

                <a-form-item :label="$t('org.linkMan')" v-bind="formItemLayout">
                    <a-input size="small" v-model="contacts" v-decorator="['contacts',{ rules: [{ max: 20, message: $t('org.validateTip.linkManRule')}, { validator: hasSpecialChar}] }]"></a-input>
                </a-form-item>

                <a-form-item :label="$t('org.phone')" v-bind="formItemLayout">
                    <a-input size="small" v-model.number="contactsPhone" v-decorator="['contactsPhone',{ rules: [{ pattern: /^1[34578]\d{9}$/, message: $t('org.validateTip.phoneRule')}] }]"></a-input>
                </a-form-item>

                <a-form-item :label="$t('org.email')" v-bind="formItemLayout">
                    <a-input size="small" v-model="email" v-decorator="['email',{ rules: [{ type: 'email', message: $t('org.validateTip.emailRule')}] }]"></a-input>
                </a-form-item>

                <a-form-item :wrapper-col="{ span: 12, offset: 3 }">
                    <a-button type="primary" @click="gotoLocate">{{$t('org.next')}}</a-button>
                </a-form-item>
            </a-form>

            <a-form :form="locateForm" v-show="locateStatus == 'process'">
                <a-form-item :label="level == 2 ? $t('org.integratorAddress') : $t('org.orgAddress')" v-bind="formItemLayout">
                    <a-input style="max-width:300px" size="small" disabled v-model="address" v-decorator="['address',{ rules: [{ required: true, message:level == 2 ? '集成商地址未设置！' : '机构地址未设置！' }] }]"></a-input>
                    <a-button size="small" style="margin-left:10px" type="primary" @click="setLocate" :disabled="mkrTool && mkrTool._isOpen">{{$t('global.set')}}</a-button>
                    <SearchAddress :map="bmap"  width="80%" top="40px"/>
                </a-form-item>
                
                <div :style="{ height: '400px', width: '100%'}">
                    <!-- <ve-bmap
                            :height="'100%'"
                            :width="'100%'"
                            :settings="chartSettings"
                            :series="chartSeries"
                            :after-set-option-once="afterSet">
                    </ve-bmap> -->
                    <BMap @getMap="getMap"  />
                </div>

                <a-form-item :wrapper-col="{ span: 12, offset: 3 }" style="margin-top:10px">
                    <a-button @click="gotoBasic">{{$t('org.pre')}}</a-button>
                    <a-button style="margin-left:10px" type="primary" @click="gotoUser">{{$t('org.next')}}</a-button>
                </a-form-item>
            </a-form>

            <a-form :form="userForm" v-show="userStatus == 'process'">
                <a-form-item :label="$t('org.userName')" v-bind="formItemLayout">
                    <a-input size="small" v-model="username" v-decorator="['username',{ rules: [
                        { required: true, message: $t('org.validateTip.userNameRequired') },
                        { max:20, min: 3, message:$t('org.validateTip.userNameRule')},
                        { validator: hasSpecialChar},
                        { validator: queryHasSameUserName}
                        ],
                        validateTrigger: 'blur' }]"></a-input>
                </a-form-item>

                <a-form-item :label="$t('org.password')" v-bind="formItemLayout">
                    <a-input size="small" type="password" v-model="password" v-decorator="['password',{ rules: [
                        { required: true, message: $t('org.validateTip.passwordRequired') },
                        {max:15,message:$t('org.validateTip.passwordRule')},
                        {min:6,message:$t('org.validateTip.passwordRule')},
                        ] }]"></a-input>
                </a-form-item>

                <a-form-item :label="$t('org.confirmPassword')" v-bind="formItemLayout">
                    <a-input size="small" type="password" v-model="passwordConfirm" v-decorator="['passwordConfirm',{ rules: [{ required: true, message: $t('org.validateTip.confirmPasswordRequired') },{ validator: checkPasswordConfirm }] }]"></a-input>
                </a-form-item>

                <a-form-item :label="$t('org.nickName')" v-bind="formItemLayout">
                    <a-input size="small" v-model="nickname" v-decorator="['nickname',{ rules: [
                        { required: true, message: $t('org.validateTip.nickNameRequired') },
                        { max:20, min: 1, message:$t('org.validateTip.nickNameRule')},
                        { validator: hasSpecialChar}
                        ]}]"></a-input>
                </a-form-item>

                <!-- <a-form-item :label="$t('org.role')" v-bind="formItemLayout">
                    <a-input size="small" v-model="roleName" disabled></a-input>
                </a-form-item> -->

                <a-form-item :label="$t('org.phone')" v-bind="formItemLayout">
                    <a-input size="small" v-model="userPhone"  v-decorator="['userPhone',{ rules: [{ pattern: /^1[34578]\d{9}$/, message: $t('org.validateTip.phoneRule')}] }]"></a-input>
                </a-form-item>

                <a-form-item :label="$t('org.avatar')" v-bind="formItemLayout">
                    <a-avatar size="large" v-if="userLogo" :src= "userLogo"/>
                    <span v-else>{{$t('global.none')}}</span>
                    <a-upload
                            :action="imageUploadUrl + '?type=user'"
                            :format="['jpg','png','jpeg','bmp']"
                            :beforeUpload="beforeUpload"
                            :showUploadList="false"
                            @change="handleChange"
                            :headers="token">
                        <a-button size="small" type="primary" style="margin-left:15px">
                            <a-icon type="upload" style="padding-right:4px"/>
                            {{$t('global.upload')}}
                        </a-button>
                    </a-upload>

                    <a-button size="small" style="margin-left:15px" @click="deleteUserLogo" v-if="userLogo">
                        <a-icon type="delete" style="padding-right:4px"/>
                        {{$t('global.delete')}}
                    </a-button>
                </a-form-item>

                <a-alert style="left:12%;width:65%" :message="$t('global.tips')" type="info" showIcon>
                    <p slot="description">
                        1：{{$t('global.imgTypeTip')}}
                        <br/>
                        2：{{$t('global.imgSizeTip')}}
                    </p>
                </a-alert>

                <a-form-item :wrapper-col="{ span: 12, offset: 3 }" style="margin-top:10px">
                    <a-button @click="gotoLocate">{{$t('org.pre')}}</a-button>
                    <a-button style="margin-left:10px" type="primary" @click="gotoCustomer">{{$t('org.next')}}</a-button>
                </a-form-item>
            </a-form>

            <a-form :form="customerForm" v-show="customerStatus == 'process'">
                <a-form-item :label="$t('org.entityTemplate')" v-bind="formItemLayout" v-if="level >= 3 && (isSuperAdmin || isIntegrator)">
                    <a-select  v-if="level == 3" v-model="entityTemplateId" size="small" v-decorator="['entityTemplateId',{ rules: [{ required: true, message: '请选择实体模板!' }] }]">
                        <a-select-option v-for="template in entityTemplates" :key="template.id" >{{template.name}}</a-select-option>
                    </a-select>
                    <a-input v-else size="small" v-model="entityTemplateName" disabled></a-input>
                </a-form-item>

                <!-- <a-form-item label='系统名称' v-bind="formItemLayout">
                    <a-input size="small" v-model="systemName" v-decorator="['systemName',{ rules: [{ required: true, message: '请输入系统名称!' },{ validator: hasSpecialChar},{max:15,message:'系统名称应在15字内'}] }]"></a-input>
                </a-form-item> -->

                <a-form-item :label="$t('org.systemName')" v-bind="formItemLayout">
                    <a-input size="small" v-model="systemName" ></a-input>
                </a-form-item>

                <a-form-item :label="$t('org.systemLogo')" v-bind="formItemLayout">
                    <a-avatar shape="square" size="large" v-if="systemLogo" :src= "systemLogo"/>
                    <span v-else>{{$t('global.none')}}</span>
                    <a-upload
                            :action="imageUploadUrl + '?type=system'"
                            :format="['jpg','png','jpeg','bmp']"
                            :beforeUpload="beforeUpload"
                            :showUploadList="false"
                            @change="handleChange"
                            :headers="token">
                        <a-button size="small" type="primary" style="margin-left:15px">
                            <a-icon type="upload" style="padding-right:4px"/>
                            {{$t('global.upload')}}
                        </a-button>
                    </a-upload>

                    <a-button size="small" style="margin-left:15px" @click="deleteSystemLogo" v-if="systemLogo">
                        <a-icon type="delete" style="padding-right:4px"/>
                        {{$t('global.delete')}}
                    </a-button>
                </a-form-item>

                <a-alert style="left:12%;width:80%" :message="$t('global.tips')" type="info" showIcon>
                    <p slot="description">
                        1：{{$t('global.imgTypeTip')}}
                        <br/>
                        2：{{$t('global.imgSizeTip')}}
                    </p>
                </a-alert>

                <a-form-item :wrapper-col="{ span: 12, offset: 3 }" style="margin-top:10px">
                    <a-button @click="gotoUser">{{$t('org.pre')}}</a-button>
                    <a-button style="margin-left:10px" type="primary" @click="handleOk">{{$t('global.OK')}}</a-button>
                </a-form-item>
            </a-form>
        </a-card>
    </div>
</template>

<script>
    import config from '../../config'
    import {mapGetters} from 'vuex'
    import {hasSpecialChar} from '../../utils/formFunctions'
    import SearchAddress from '../../components/BMapComponents/SearchAddress'
    import { baiduKey } from '../../config/baiduKey'
     import BMap from '@/components/common/BMap'
    export default {
        name: "ZAddOrg",
        components: {
          SearchAddress,
          BMap,
        },
        props:['entityTemplates'],
        computed: {
            ...mapGetters([
                'isSuperAdmin','isIntegrator'
            ])
        },
        data () {
            return {
                link: null,
                bmap: null,
                pid:null,
                orgName:null,
                orgDescription: null,
                parentOrg: null,
                contacts: null,
                contactsPhone: null,
                email: null,
                address: null,
                city: null,
                lat: null,
                lng: null,
                username: null,
                nickname: '',
                password: null,
                passwordConfirm: null,
                userLogo: '',
                userPhone: null,
                systemName: null,
                systemLogo: '',
                roleName: null,
                entityTemplateId: null,
                entityTemplateName: null,
                level: null,
                basicForm: null,
                locateForm: null,
                userForm: null,
                customerForm: null,
                basicStatus: 'process',
                locateStatus: 'wait',
                userStatus: 'wait',
                customerStatus: 'wait',
                chartSettings: [],
                chartSeries: [],
                mkrTool: null,
                locateMarker: null,
                imageUploadUrl: config.api.file_upload_url,
                token: {},
                formItemLayout: {
                    labelCol: {
                        xs: { span: 20 },
                        sm: { span: 3 },
                    },
                    wrapperCol: {
                        xs: { span: 24 },
                        sm: { span: 16 },
                    }
                }
            }
        },
        methods:{
            getMap (map) {
                this.bmap = map
                let drawingManager = new window.BMapLib.DrawingManager(this.bmap, {
                        isOpen: false, //是否开启绘制模式
                        enableDrawingTool: false, //是否显示工具栏
                    });
                this.drawingManager = drawingManager
                let _this = this
                drawingManager.addEventListener('overlaycomplete', function(e){
                    if(e.drawingMode == 'circle'){
                        //画圆
                        //console.log(e.overlay.getCenter().lat + ',' + e.overlay.getCenter().lng)
                        //console.log(e.overlay.getRadius())
                        _this.circle = e.overlay.getRadius()

                    }else if(e.drawingMode == 'polygon'){
                        //画多边形
                        //console.log(JSON.stringify(e.overlay.getPath()))
                    }
                    _this.clearOverlays();

                    _this.overlays.push(e.overlay)
                    _this.drawingManager.close()
                });
             },
            deleteUserLogo(){
                this.userLogo = ''
            },
            deleteSystemLogo() {
                this.systemLogo = ''
            },
            hasSpecialChar,
            // 查询机构名称是否被占用
            queryHasSameOrgName (rule, value, callback) {
                let params = {parentLink: this.link, name: value}
                // console.log(params)
                this.$http.post(config.api.check_has_same_org_name, params).then((res) => {
                    // console.log(res)
                    if (res.code === 0) {
                        callback()
                    } else {
                        callback(res.desc)
                    }
                })
            },
            // 查询用户名称是否被占用
            queryHasSameUserName (rule, value, callback) {
                let params = {name: value}
                // console.log(params)
                this.$http.post(config.api.check_has_same_user_name, params).then((res) => {
                    console.log(res)
                    if (res.code === 0) {
                        callback()
                    } else {
                        callback(res.desc)
                    }
                })
            },
            getScrollTop: function () {
                let scrollTop = 0;
                if (document.documentElement && document.documentElement.scrollTop) {
                    scrollTop = document.documentElement.scrollTop;
                } else if (document.body) {
                    scrollTop = document.body.scrollTop;
                }
                return scrollTop;
            },
            setScrollTop: function (top) {
                if (!isNaN(top)) {
                    if (document.documentElement && document.documentElement.scrollTop !== undefined) {
                        document.documentElement.scrollTop = top;
                    } else if (document.body) {
                        document.body.scrollTop = top;
                    }
                }
            },
            beforeUpload (file) {
                if(file.type.indexOf('image/') == -1){
                    this.$notification["warning"]({
                        message: this.$t('global.tips'),
                        description: this.$t('global.imgTypeTip'),
                    });
                    return false
                }
                let fileSize = file.size
                if(fileSize >= 1048576){
                    this.$notification["warning"]({
                        message: this.$t('global.tips'),
                        description: this.$t('global.imgSizeTip'),
                    });
                    return false
                }
                return true
            },
            handleChange(info) {
                if (info.file.status === 'done' && info.file.response.code == 0) {
                    if(info.file.response.result.type == 'user'){
                        this.userLogo = info.file.response.result.imageUrl
                    }
                    else if(info.file.response.result.type == 'system'){
                        this.systemLogo = info.file.response.result.imageUrl
                    }
                }
            },
            checkPasswordConfirm(rule, value, callback){
                if(this.password == this.passwordConfirm){
                    callback();
                    return
                }
                callback(this.$t('org.validateTip.confirmPasswordRule'))
            },
            handleOk(){
                this.customerForm.validateFieldsAndScroll((err) => {
                    if(!err){
                        let user = {}
                        user.username = this.username
                        user.password = this.password
                        user.imageUrl = this.userLogo
                        user.phone = this.userPhone
                        user.nickname = this.nickname
                        let org = {}
                        user.org = org
                        org.name = this.orgName
                        org.remark = this.orgDescription
                        org.address = this.address
                        org.contacts = this.contacts
                        org.contactsPhone = this.contactsPhone
                        org.pid = this.pid
                        org.lat = this.lat
                        org.lng = this.lng
                        if(this.level == 3){
                            org.entityTemplateId = this.entityTemplateId
                        }
                        org.coordType = 'BD09'
                        org.mapLevel = this.bmap.getZoom()
                        org.email = this.email
                        org.region = this.city
                        org.logo = this.systemLogo
                        org.systemName = this.systemName
                        let url = config.api.users_url
                        switch(this.level){
                            case 2:{
                                url += '/integrator'
                                break;
                            }
                            case 3:{
                                url += '/topOrg'
                                break;
                            }
                            default:{
                                url += '/org'
                            }
                        }
                        // console.log(user)
                        this.$http.post(url,user).then((response) => {
                            // console.log(response)
                            if(response.code == 0){
                                this.$notification.success({
                                  message: this.$t('org.addOrgSuccess')
                                })
                                let orgId = response.result.org.id
                                this.$emit("addSuccess",orgId)
                            } else {
                                this.$message.error(response.desc)
                            }
                        })
                    }
                })
            },
            showAddOrg(org){
                // console.log(org)
                this.pid = org.id
                this.link = org.link
                this.level = org.link.split(',').length
                switch (this.level){
                    case 2: {
                        this.roleName = '集成商';
                        break;
                    }
                    case 3: {
                        this.roleName = '一级机构管理员';
                        break;
                    }
                    default: {
                        this.roleName = '机构管理员'
                        this.entityTemplateName = org.entityTemplateName
                    }
                }
                this.basicForm = this.$form.createForm(this)
                this.locateForm = this.$form.createForm(this)
                this.userForm = this.$form.createForm(this)
                this.customerForm = this.$form.createForm(this)
                this.parentOrg = org.name
                this.basicStatus = 'process'
                this.locateStatus = 'wait'
                this.userStatus = 'wait'
                this.customerStatus = 'wait'
                this.contacts = null
                this.contactsPhone = null
                this.email = null
                this.userPhone = null
                this.top = this.getScrollTop()
                if (this.top) {
                    this.setScrollTop(0)
                }
            },
            setLocate(){
                this.mkrTool.open()
            },
            gotoBasic(){
                this.basicStatus = 'process'
                this.locateStatus = 'wait'
            },
            gotoLocate(){
                let _this = this
                this.basicForm.validateFieldsAndScroll((err) => {
                    if(!err){
                        this.basicStatus = 'finish'
                        this.locateStatus = 'process'
                        this.userStatus = 'wait'

                        if(this.bmap){
                            if(!_this.cityListControl){
                                setTimeout(() => {
                                    var size = new window.BMap.Size(10, 20);
                                    _this.cityListControl = new window.BMap.CityListControl({
                                        anchor: window.BMAP_ANCHOR_TOP_LEFT,
                                        offset: size,
                                    })
                                    _this.bmap.addControl(_this.cityListControl);
                                },200)
                            }

                            if(!_this.mkrTool){
                                window.BMapLib._toolInUse = false
                                _this.mkrTool = new window.BMapLib.MarkerTool( _this.bmap, {autoClose: true, followText: ""})
                                _this.mkrTool.addEventListener("markend", function(e) {
                                    _this.bmap.removeOverlay(e.marker)
                                    if(_this.locateMarker){
                                        _this.bmap.removeOverlay(_this.locateMarker)
                                    }
                                    _this.locateMarker = new window.BMap.Marker({"lat":e.marker.point.lat,"lng":e.marker.point.lng});
                                    _this.bmap.addOverlay(_this.locateMarker)

                                    var geoc = new window.BMap.Geocoder()
                                    var pt = new window.BMap.Point(e.marker.point.lng,e.marker.point.lat)
                                    geoc.getLocation(pt, function (rs) {
                                        if (rs.address !== '') {
                                            _this.address  = rs.address;
                                        }else {
                                            if ((rs.addressComponents.city !== '') && (rs.addressComponents.country !== '')) {
                                                _this.address  = rs.addressComponents.city + ', ' + rs.addressComponents.country;
                                            }
                                        }
                                        if(rs.addressComponents.city !== ''){
                                            _this.city = rs.addressComponents.city
                                        }
                                        _this.lat = e.marker.point.lat
                                        _this.lng = e.marker.point.lng
                                        _this.locateForm.setFieldsValue({
                                            address:  _this.address
                                        });
                                    })
                                })
                            }
                        }
                    }
                })
            },
            gotoUser(){
                this.locateForm.validateFieldsAndScroll((err) => {
                    if(!err){
                        this.locateStatus = 'finish'
                        this.userStatus = 'process'
                        this.customerStatus = 'wait'
                    }
                })
            },
            gotoCustomer(){
                this.userForm.validateFieldsAndScroll((err) => {
                    if(!err){
                        this.userStatus = 'finish'
                        this.customerStatus = 'process'
                    }
                })
            },
            afterSet: function (echarts) {
                this.bmap = echarts.getModel().getComponent('bmap').getBMap()
            }
        },
        created () {
            this.chartSettings = {
                key: baiduKey,
                bmap: {
                    center: [116.417854, 39.921988],
                    zoom: 18,
                    roam: true,
                    mapStyle: {}
                }
            }
            this.chartSeries = []
            this.token = {Authorization:'Bearer ' + this.$store.getters.token}
        }
    }
</script>